import AddInterviewPage from '../../js/pages/AddInterviewPage';

AddInterviewPage.getLayout = (page) => page;

export default AddInterviewPage;
